<template>
  <div id="app">
    <screen/>
  </div>
</template>

<script>
import screen from './components/screen.vue'

export default {
  name: 'app',
  components: {
    screen
  }
}
</script>

<style>
body,html,#app{
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-size: cover;
  background-repeat: no-repeat;
  min-width: 1920px;
  min-height: 1080px;
}
</style>
